import { ACTION } from "@common/constants/redux";

export const setConfigPopupFilter = (filter) => {
  return (dispatch) => {
    dispatch({
      type: ACTION.SET_POPUP_FILTER,
      payload: filter,
    });
  };
};
